import React, { useState, useEffect } from "react";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
//import { CountrySelect, GetCountries } from "react-country-state-city";
//import "react-country-state-city/dist/react-country-state-city.css";
import axios from "axios";
import Spinner from "../../LoadingSpinner/loadingSpinner";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import api from "../../../api";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import countryList from "react-select-country-list";
import { useMemo } from "react";
const Editprofile = ({ data ,profileData  }) => {
  const [phones, setPhoneNumbers] = useState([""]);
  const [emails, setEmails] = useState([""]);
  const [gender, setGender] = useState("");
  const [languageData, setLanguageData] = useState(null);
  const countryOptions = useMemo(() => countryList().getData(), []);
  const [country, setCountry] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [language, setLanguage] = useState("en");
  const [username, setUsername] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [nickname, setNickname] = useState("");
  const [loading, setLoading] = useState(false);
  const [countryReady, setCountryReady] = useState(false);
  const [birthdate, setBirthdate] = useState({
    day: "",
    month: "",
    year: "",
  });
  useEffect(() => {
if (!profileData?.user) return;

  const user = profileData.user;

  setGender(user.gender || "");
  setUsername(user.nickname || "");
  setFirstname(user.firstname || "");
  setLastname(user.lastname || "");
  setNickname(user.nickname || "");

  setEmails(
    Array.isArray(user.email_addresses)
      ? user.email_addresses
      : [""]
  );

  setPhoneNumbers(
    Array.isArray(user.phone_numbers) && user.phone_numbers.length > 0
      ? user.phone_numbers
      : [""]
  );

  setLanguage(user.language || "en");

  if (user.birthdate) {
    const [year, month, day] = user.birthdate.split("-");

    setBirthdate({
      day,
      month,
      year,
    });
  }

  if (user.country) {
    const foundCountry = countryOptions.find(
      (c) => c.value === user.country
    );

    if (foundCountry) {
      setCountry(foundCountry);
    }
  }
}, [profileData, countryOptions]);

  const addPhoneNumber = () => {
    setPhoneNumbers((prev) => [...prev, ""]);
  };

  const addEmail = () => {
    setEmails((prev) => [...prev, ""]);
  };

  const handlePhoneChange = (index, value) => {
    setPhoneNumbers((prev) => {
      const updated = [...prev];
      updated[index] = value;
      return updated;
    });
  };

  const handleEmailChange = (index, value) => {
    const updatedEmails = [...emails];
    updatedEmails[index] = value;
    setEmails(updatedEmails);
  };

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../../lang/profile/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  const updateStoredUserData = (updatedUser) => {
      const userInfoKey = process.env.REACT_APP_USER_INFO;
  const horoscopeKey = process.env.REACT_APP_USER_INFO_HOROSCOPE;

  const updateLocalStorageData = (key) => {
    const existingData = localStorage.getItem(key);

    if (!existingData) return;

    try {
      const parsedData = JSON.parse(existingData);

      const mergedData = {
        ...parsedData,
        ...updatedUser,
      };

      localStorage.setItem(key, JSON.stringify(mergedData));
    } catch (error) {
      console.error(`Invalid localStorage data for ${key}`, error);

      localStorage.setItem(key, JSON.stringify(updatedUser));
    }
  };

  updateLocalStorageData(userInfoKey);
  updateLocalStorageData(horoscopeKey);
/*     const userInfoKey = process.env.REACT_APP_USER_INFO;
    const horoscopeKey = process.env.REACT_APP_USER_INFO_HOROSCOPE;

    const updateCookieData = (key) => {
      const existingData = Cookies.get(key);
      if (!existingData) return;

      try {
        const parsedData = JSON.parse(existingData);

        const mergedData = {
          ...parsedData,
          ...updatedUser,
        };

        Cookies.set(key, JSON.stringify(mergedData), { path: "/" });
      } catch (error) {
        console.error(`Invalid cookie data for ${key}`, error);

        Cookies.set(key, JSON.stringify(updatedUser), { path: "/" });
      }
    };

    updateCookieData(userInfoKey);
    updateCookieData(horoscopeKey); */
  };
  window.dispatchEvent(new Event("user_updated"));
const cleanedPhones = phones.filter((phone) => {
  if (!phone) return false;
  const value = phone.trim();
  const digits = value.replace(/\D/g, "");
  return digits.length > 4;
});
  const handleUpdateProfile = async () => {
    setLoading(true);
    try {
      const day = birthdate.day.toString().padStart(2, "0");
      const month = birthdate.month.toString().padStart(2, "0");
      const year = birthdate.year;

      const formattedBirthdate = `${year}-${month}-${day}`;

      const cleanedPhones = phones.filter((phone) => {
      if (!phone) return false;

      const value = phone.trim();
      const digits = value.replace(/\D/g, "");

      return digits.length > 4;
    });

      const payload = {
        username: nickname,
        firstname: firstname,
        lastname: lastname,
        birthdate: formattedBirthdate,
        phones: cleanedPhones,
        emails: emails,
        gender: gender,
        country: country,
        language: language,
        country: country?.value || "",
      };
      const response = await api.post(`/accounts/profile/update`, payload);

      if (response.data?.status === "success") {
        const updatedUser = {
          user_id: response.data.data.user_id,
          account_id: response.data.data.account_id,
          firstname,
          lastname,
          nickname,
          birthdate: formattedBirthdate,
          emails: emails,
          phones: cleanedPhones,
          gender,
          country: country?.value || "",
          language,
        };

        updateStoredUserData(updatedUser);
        setEmails(emails);
        setPhoneNumbers(cleanedPhones);

        setLoading(false);
        Swal.fire(
          languageData?.alert?.update_success?.title,
          languageData?.alert?.update_success?.description,
          "success",
        );
      }
    } catch (error) {
      setLoading(false);
      const details = error.response?.data?.details;

      const message = details
        ? details.map((d) => `• ${d.message}`).join("\n")
        : error.response?.data?.message || "Login failed";

      Swal.fire({
        text: message,
        icon: "error",
      });
    }
  };
  const getCountryFromBrowser = () => {
    const lang = navigator.language || navigator.languages[0];
    return lang?.split("-")[1]?.toLowerCase() || "us";
  };

  const [defaultCountry, setDefaultCountry] = useState("us");

  useEffect(() => {
    setDefaultCountry(getCountryFromBrowser());
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  return (
    <div
      className="tab-pane show active fade border-0 bg-white p-4 rounded-3"
      id="profile-tab-pane"
      role="tabpanel"
      aria-labelledby="profile-tab"
      tabIndex="0"
    >
      <div className="row gy-3">
        <div className="col-xl-12">
          <label htmlFor="username" className="form-label">
            {languageData.tab_profile.username}{" "}
            <small className="text-danger">*</small>
          </label>
          <input
            type="text"
            className="form-control"
            id="username"
            name="username"
            value={nickname}
           onChange={(e) => setNickname(e.target.value)}
          />
        </div>

        <div className="col-xl-6">
          <label htmlFor="blog-author" className="form-label">
            {languageData.tab_profile.gender.title}{" "}
            <small className="text-danger">*</small>
          </label>
          <div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="gender"
                id="genderM"
                value="male"
                checked={gender === "male"}
                onChange={(e) => setGender(e.target.value)}
              />
              <label className="form-check-label" htmlFor="genderM">
                {languageData.tab_profile.gender.male}
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="gender"
                id="genderF"
                value="female"
                checked={gender === "female"}
                onChange={(e) => setGender(e.target.value)}
              />
              <label className="form-check-label" htmlFor="genderF">
                {languageData.tab_profile.gender.female}
              </label>
            </div>
          </div>
        </div>

        <div className="col-xl-6">
          <label htmlFor="birthdate" className="form-label">
            {languageData.tab_profile.birthdate}{" "}
            <small className="text-danger">*</small>
          </label>
          <div className="d-flex align-items-center justify-content-between gap-1">
            <div className="w-100">
              <input
                type="number"
                min="1"
                max="31"
                name="date"
                className="form-control"
                placeholder="01"
                value={birthdate.day || ""}
                onChange={(e) =>
                  setBirthdate((prev) => ({ ...prev, day: e.target.value }))
                }
              />
            </div>
            <div className="w-100">
              <input
                type="number"
                min="1"
                max="12"
                name="month"
                className="form-control"
                placeholder="01"
                value={birthdate.month || ""}
                onChange={(e) =>
                  setBirthdate((prev) => ({ ...prev, month: e.target.value }))
                }
              />
            </div>
            <div className="w-100">
              <input
                type="number"
                min="1900"
                max="2100"
                name="year"
                className="form-control"
                placeholder="1980"
                value={birthdate.year || ""}
                onChange={(e) =>
                  setBirthdate((prev) => ({ ...prev, year: e.target.value }))
                }
              />
            </div>
          </div>
        </div>

        <div className="col-xl-6">
          <label htmlFor="firstname" className="form-label">
            {languageData.tab_profile.firstname}
          </label>
          <input
            type="text"
            className="form-control"
            name="firstname"
            id="firstname"
           value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
          />
        </div>

        <div className="col-xl-6">
          <label htmlFor="lastname" className="form-label">
            {languageData.tab_profile.lastname}
          </label>
          <input
            type="text"
            className="form-control"
            id="lastname"
            name="lastname"
            value={lastname}
            onChange={(e) => setLastname(e.target.value)}
          />
        </div>

        <div className="col-xl-6">
          <label htmlFor="country" className="form-label">
            {languageData.tab_profile.country.title}
          </label>
          <Select
            options={countryOptions}
            value={country}
            name="country"
            onChange={(selectedOption) => {
              setCountry(selectedOption);
            }}
            placeholder="Select Country"
          />
        </div>

        <div className="col-xl-6">
          <label htmlFor="language" className="form-label">
            {languageData.tab_profile.languages.title}
          </label>
          <select
            className="js-example-templating js-persons form-control"
            value={language}
            name="language"
            onChange={(e) => setLanguage(e.target.value)}
          >
            <option value="en"> {languageData.tab_profile.languages.en}</option>
            <option value="fr">{languageData.tab_profile.languages.fr}</option>
          </select>
        </div>

        <div className="col-xl-6">
          <label htmlFor="email" className="form-label mb-0">
            {languageData.tab_profile.email}{" "}
            <small className="text-danger">*</small>
          </label>
          <div id="email-container" className="d-flex flex-column gap-3">
            {Array.isArray(emails) &&
              emails.map((email, index) => (
                <input
                  key={index}
                  type="email"
                  className="form-control"
                  id={`email-${index}`}
                  name="email"
                  placeholder="Email@xyz.com"
                  value={email}
                  onChange={(e) => handleEmailChange(index, e.target.value)}
                />
              ))}
          </div>
          <button data-interaction="add_email_button"
            type="button"
            id="add-email"
            className="btn btn-sm btn-outline-light btn-wave waves-effect waves-light plus-btn mt-2"
            onClick={addEmail}
          >
            <i className="bx bx-plus"></i>
            {languageData.tab_profile.add_email}
          </button>
        </div>

        <div className="col-xl-6">
          <label htmlFor="phone" className="form-label mb-0">
            {languageData.tab_profile.phone}{" "}
            <small className="text-danger">*</small>
          </label>
          <div>
            <div
              id="phone-container"
              className="d-flex flex-column gap-3 w-100"
            >
              {Array.isArray(phones) &&
                phones.map((phone, index) => (
                  <div
                    key={`phone-input-${index}`}
                    className="phone-input-wrapper"
                  >
                    <PhoneInput
                      country={defaultCountry}
                      value={phone ?? ""}
                      onChange={(value) => handlePhoneChange(index, value)}
                      forceDialCode={true}
                      disableDialCodePrefill={false}
                      inputProps={{
                        name: `phone-${index}`,
                        autoComplete: "off",
                      }}
                      className="form-control p-0  phone_input"
                      inputStyle={{
                        width: "100%",
                        height: "34px",
                        border: "none",
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        paddingLeft: "8px",
                      }}
                      countrySelectorStyleProps={{
                        buttonStyle: {
                          border: "none",
                          borderRight: "1px solid #dee2e6",
                          borderRadius: "0.375rem 0 0 0.375rem",
                          backgroundColor: "transparent",
                          height: "32px",
                        },
                      }}
                    />
                  </div>
                ))}
            </div>
          </div>

          <button data-interaction="add_phone_buoon"
            type="button"
            id="add-phone-btn"
            className="btn btn-sm btn-outline-light btn-wave waves-effect waves-light plus-btn mt-2"
            onClick={addPhoneNumber}
          >
            <i className="bx bx-plus"></i>
            {languageData.tab_profile.add_phone}
          </button>
        </div>
      </div>
      <div className="row gy-3 mt-3">
        <hr></hr>
        <div className="text-end m-0">
          <button data-interaction="update_profile_button"
            type="button"
            className="btn btn-primary"
            onClick={handleUpdateProfile}
          >
            {languageData.tab_profile.button}
          </button>
        </div>
      </div>
      {/* Spinner Overlay */}
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default Editprofile;
